import { PengelolaanKinerjaTimeline } from 'app/KinerjaShared/components/PengelolaanKinerjaTimeline'
import KinerjaSidebar from 'app/KinerjaShared/components/KinerjaSidebar'
import { PeriodikPejabatPenilaiKinerjaCard } from 'app/KinerjaAsnSwastaPage/components/PeriodikPejabatPenilaiKinerjaCard'

export function Homepage() {
  return (
    <div className="flex w-full min-h-screen">
      <div className="flex-shrink-0 min-h-full">
        <div className="w-64">{/* Sentinel element for sidebar spacing */}</div>
        <KinerjaSidebar activeMenu="kadin-asn-swasta" sticky />
      </div>
      <div className="w-full gap-4 p-6 space-y-6">
        <PeriodikPejabatPenilaiKinerjaCard />

        <PengelolaanKinerjaTimeline
          timeline={[
            {
              title: 'Januari',
              steps: ['Perencanaan Kinerja'],
            },
            {
              title: 'Februari - November',
              steps: [
                'Persiapan Praktik Kinerja',
                'Pelaksanaan Observasi Praktik Kinerja',
                'Pelaksanaan Tindak Lanjut Praktik Kinerja',
              ],
            },
            {
              title: 'Desember',
              steps: ['Rekomendasi Predikat Kinerja'],
            },
          ]}
        />
      </div>
    </div>
  )
}
